var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text--twoCol",domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }